import { keys } from "../strings";

const DEFAULT_FACTOR = 1;
const MAX_FACTOR = 20;

function isSlowMotionAllowed(): boolean {
  return process.env.NODE_ENV !== "production";
}

export function readCompletionSlowMotionFactor(): number {
  if (!isSlowMotionAllowed()) {
    return DEFAULT_FACTOR;
  }
  try {
    const raw = localStorage.getItem(
      keys.localStorage.completionAnimationSlowMotion,
    );
    if (!raw) {
      return DEFAULT_FACTOR;
    }
    const parsed = Number.parseFloat(raw);
    if (!Number.isFinite(parsed) || parsed < 1) {
      return DEFAULT_FACTOR;
    }
    return Math.min(parsed, MAX_FACTOR);
  } catch {
    return DEFAULT_FACTOR;
  }
}

export function writeCompletionSlowMotionFactor(factor: number): void {
  if (!isSlowMotionAllowed()) {
    return;
  }
  try {
    if (!Number.isFinite(factor) || factor <= 1) {
      localStorage.removeItem(keys.localStorage.completionAnimationSlowMotion);
      return;
    }
    localStorage.setItem(
      keys.localStorage.completionAnimationSlowMotion,
      String(Math.min(factor, MAX_FACTOR)),
    );
  } catch {
    // ignore
  }
}

export function scaleCompletionDurationMs(ms: number): number {
  return Math.round(ms * readCompletionSlowMotionFactor());
}
